import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
export function FormStep({ show, title, description, children }) {
    return (_jsxs("fieldset", Object.assign({ className: clsx('form-step', !show && 'form-step--hide') }, { children: [_jsx("h3", Object.assign({ className: "form-step__title" }, { children: title })), description && _jsx("p", Object.assign({ className: "form-step__description" }, { children: description })), children] })));
}
